/*SYSTEM IMPORTS*/
    import React, { PureComponent } from 'react'
    import c from 'classnames'

    import Link from 'components/Link'
    
    import { IsIsset } from 'helpers/ValueTests'

    class Avatar extends PureComponent {
        render() {
            const { props = {} } = this

            const {
                text = null,
                image = null,
                to = undefined,
                onClick = undefined,
                target = undefined,
                online = false,
                children = null,
                className = "",
                theme = false
            } = props

            return (
                <div className={c( "avatar", { online, theme }, className )}>
                    { IsIsset( to ) && <Link target={ target } to={ to } onClick={ onClick } className="photo">
                        {text}
                        {image}
                    </Link> }
                    { !IsIsset( to ) && <div onClick={ onClick } className="photo">
                        {text}
                        {image}
                    </div> }
                    { children }
                </div>
            )
        }
    }

    export default Avatar
